import { Auth } from "aws-amplify";
import { Formik } from "formik";
import React, { useState } from "react";
import { InputGroup } from "react-bootstrap";
import { MdVisibility, MdVisibilityOff } from "react-icons/md";
import { toast } from "react-toastify";
import * as yup from "yup";
import FormikPasswordField from "../../components/Forms/FormikPasswordField";
import FormikTextField from "../../components/Forms/FormikTextField";
import LoaderButton from "../../components/LoaderButton";
import "./ChangePassword.scss";
import SettingLayout from "./settinglayout";

const initialValues = {
  oldpassword: "",
  password: "",
};
const schema = yup.object({
  oldpassword: yup.string().required("Current password is required"),
  password: yup
    .string()
    .required("Password is required")
    .min(8, "Must meet all requirements")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!_@#\$%\^&\*])(?=.{8,})/,
      "Must meet all requirements"
    ),
});

const ChangePassword = ({ setLoading }) => {
  const [visibility, setVisibility] = useState(true);

  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      const currentUser = await Auth.currentAuthenticatedUser();
      await Auth.changePassword(
        currentUser,
        values.oldpassword,
        values.password
      );
      toast.success("Password updated successfully");
    } catch (e) {
      toast.error(e.message);
    }
    setLoading(false);
  };
  return (
    <SettingLayout title="Create New Password">
      <Formik
        validationSchema={schema}
        onSubmit={async (values, { resetForm }) => {
          await handleSubmit(values);
          resetForm();
        }}
        initialValues={initialValues}
        enableReinitialize
        validateOnMount
      >
        {({ handleSubmit, isValid, isSubmitting }) => (
          <form noValidate onSubmit={handleSubmit} className="w-100 p-5">
            <FormikTextField
              size="lg"
              controlId="oldpassword"
              label="Current Password"
              type="password"
              name="oldpassword"
              className="mb-4"
            />
            <FormikPasswordField
              size="lg"
              controlId="password"
              label="New Password"
              type={!visibility ? "text" : "password"}
              name="password"
              className="mb-2"
              inputGroupAppend={
                <>
                  {!visibility && (
                    <InputGroup.Text
                      id="basic-addon2"
                      onClick={() => setVisibility(true)}
                    >
                      <MdVisibility />
                    </InputGroup.Text>
                  )}
                  {visibility && (
                    <InputGroup.Text
                      id="basic-addon2"
                      onClick={() => setVisibility(false)}
                    >
                      <MdVisibilityOff />
                    </InputGroup.Text>
                  )}
                </>
              }
            />

            <LoaderButton
              block
              type="submit"
              variant="primary"
              size="lg"
              text="Next"
              className="mb-2"
              isLoading={isSubmitting}
              disabled={!isValid || isSubmitting}
            >
              Save Changes
            </LoaderButton>
          </form>
        )}
      </Formik>
    </SettingLayout>
  );
};

export default ChangePassword;
